import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminListingsApi as n } from "@maat/api-main";
//#region src/listings/admin/useAdminListingsQuery.ts
var r = (r) => t({
	queryKey: e.list(r),
	fetchPage: (e) => n.list({
		...r,
		page: e
	}),
	key: "listings"
});
//#endregion
export { r as useAdminListingsQuery };
